import { render, staticRenderFns } from "./project-portfolio.vue?vue&type=template&id=4ea4ef79"
import script from "./project-portfolio.ts?vue&type=script&lang=ts&external"
export * from "./project-portfolio.ts?vue&type=script&lang=ts&external"
import style0 from "./project-portfolio.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ea4ef79')) {
      api.createRecord('4ea4ef79', component.options)
    } else {
      api.reload('4ea4ef79', component.options)
    }
    module.hot.accept("./project-portfolio.vue?vue&type=template&id=4ea4ef79", function () {
      api.rerender('4ea4ef79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project-portfolio/project-portfolio.vue"
export default component.exports